import { computed, makeObservable, observable } from "mobx";
import { createModelSchema, optional, primitive } from "serializr";
import { CancelType } from "../CancelType";

export class CancelReason {
  id: number | null = null;

  constructor() {
    makeObservable(this, {
      id: observable,
      name: computed
    });
  }

  get name(): string {
    return this.id ? CancelType[this.id] || '' : '';
  }
}

createModelSchema(CancelReason, {
  id: optional(primitive())
});
